<template>
  <input-widget :model="model" :attribute="attribute" type="select2" :disabled="disabled" value-field="key"
                display-field="${item.display_name}" :hint="hint" @select2Select="onSelect"
                :label="label" :options="options" @select2Unselect="onUnselect"
                :items="computed_template_types"/>
</template>


<script>
  import InputWidget from "./../components/input-widget/InputWidget";
  import {createNamespacedHelpers} from "vuex";

  const {mapState: globalMapState} = createNamespacedHelpers('global');

  /**
   * @author Saiat Kalbiev <kalbievich11@gmail.com>
   */
  export default {
    name: "TemplateTypeSelectInputWidget",
    components: {InputWidget},
    props: {
      model: {
        type: Object,
        required: true
      },
      attribute: {
        type: String,
        required: true
      },
      options: {
        type: Object,
        default: () => {
          return {};
        }
      },
      label: {
        type: [String, Boolean],
        default: null
      },
      hint: {
        type: [Boolean, String],
        default: false
      },
      disabled: {
        type: Boolean,
        default: false
      },
      excludeKeys: {
        type: Array,
        default: () => []
      }
    },
    computed: {
      ...globalMapState({
        template_types: state => state.template_types,
      }),
      computed_template_types() {
        // Exclude template keys that are in exclude_keys and that are not already selected in current select input
        return this.template_types ? this.template_types.filter(temp => temp.key === this.model[this.attribute] || !(this.excludeKeys.includes(temp.key))) : this.template_types;
      }
    },
    methods: {
      onSelect(data) {
        this.$emit('select', data);
      },
      onUnselect() {
        this.$emit('unselect');
      }
    }
  }
</script>

<style scoped>

</style>
